import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { useTranslation } from "next-i18next";
import { memo } from "react";

function PriceRange(props: any) {
  const {
    minimumPrice, maximumPrice, size, className,
  } = props;
  const { t } = useTranslation("common");

  if (!maximumPrice || !maximumPrice) {
    return null;
  }

  return (
    <PAText component="p" className={className} fontSize={size || FONT_SIZE[3]} bold>
      {t("price_range", { minimum_price: (minimumPrice / 100).toFixed(2), maximum_price: (maximumPrice / 100).toFixed(2) })}
    </PAText>
  );
}

export default memo(PriceRange);
